
import React, { useRef } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { IdentifiersDialog } from "@freyr/freyr-react-common-components";
// import useIdentifiersDialogsStore from "../../../../stores/useIdentifiersDialogsStore";
import { useShallow } from 'zustand/react/shallow';
// import { batchBindIdentifier, batchRemoveIdentifier, saveIdentifier } from "../../../../apis/apiFunctions";
import { EnqueueSnackbar } from "notistack";
import useIdentifiersDialogsStore from "../hooks/useIdentifierDialogsStore";
import { batchBindIdentifier, batchRemoveIdentifier, saveIdentifier } from "../api/identifierApi";
import SuccessIcon from "../assets/images/success-icon.svg";
import { toArray } from "../assets/utils";

interface IdentifiersDialogsProps {
  rowSelectionModel: GridRowSelectionModel;
  disableIdentifierList: string[];
  setRowSelectionModel: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>;
  queryResponseId: string;
  associatedId: string;
  parentIndetifierList?: any[];
  openSnackbar: EnqueueSnackbar
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  refresh?: (flag?: boolean) => void;
  slotprops?: any;
}


export const handleSelectedIdentifiers = (
  filterList: any,
  identifierList = [] as any[]
) => {
  let afterFilterList = {} as any;
  for (let key in filterList) {
    if (!identifierList.includes(key)) {
      if (Array.isArray(filterList[key])) {
        if (filterList[key].length > 0) {
          afterFilterList[key] = filterList[key];
        }
      } else {
        afterFilterList[key] = [filterList[key]];
      }
    }
  }
  return afterFilterList;
};


export const IdentifiersDialogs: React.FC<Partial<IdentifiersDialogsProps>> =
React.memo(function IdentifiersDialogs({
  rowSelectionModel,
  setRowSelectionModel,
  openSnackbar
}) {  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

 const hasTriggerSelectioRef = useRef<any>({});
   const identifierMapAll = useRef<any>({});
  const saveBatchBindIdentifier = (item: any) => {
    if (
      !item.identifierMap ||
      JSON.stringify(item.identifierMap) === "{}"
    )
      return;
    let body = {
      xevmpdIds: rowSelectionModel,
      identifierMap: handleSelectedIdentifiers(item.identifierMap, [])
    };
    // Implement once API is ready
    setLoading(true);
    if (item.batchAction === "add") {
      batchBindIdentifier(body as any)
        .then((data: any) => {
          onBatchIdentifierSuccess(data.data?.data);
          // refresh?.(true);
        })
        .catch((err: any) => {
          if (
            err?.response?.status === 401 ||
            err?.response?.data?.message === "unauthorized"
          ) {
            return;
          }
          openSnackbar?.(err.response.data.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        })
      .finally(() => {
        setLoading(false);
      });
    } else {
      batchRemoveIdentifier(body as any)
        .then((data: any) => {
          onBatchIdentifierSuccess(data.data?.data);
        })
        .catch((err: any) => {
          if (
            err?.response?.status === 401 ||
            err?.response?.data?.message === "unauthorized"
          ) {
            return;
          }
          openSnackbar?.(err.response.data.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const saveSingleBindIdentifier = async (item: any) => {
    const body = {
      registrationId: associatedApplicationId,
      identifierMap: handleSelectedIdentifiers(item.identifierMap),
    };
    saveIdentifier(body)
    .then(value => {
      if(value?.data?.data) {
        openSnackbar?.(t("identifiers.saveSuccess"), { variant: "success", anchorOrigin: { vertical: 'top', horizontal: 'center' } });   
      } else {
        openSnackbar?.(t("identifiers.saveError"), { variant: "error", anchorOrigin: { vertical: 'top', horizontal: 'center' } });      
      }
  
      // refresh?.(true); //implement this method, once backend is done
    })
    .catch(() => {
      openSnackbar?.(t("identifiers.saveError"), { variant: "error", anchorOrigin: { vertical: 'top', horizontal: 'center' } });      
    });
  };

  const {
    closeManageIdentifierPop, closeSingleIdentifierPop, updateOpenBulkIdentifierDialog, onBatchIdentifierSuccess,
    showManageIdentifierPop, showSingleManageIdentifierPop, openBulkIdentifierDialog, defaultAutoCheckedList:defaultIdentifierList, disableIdentifierList,
    disabledList,
    initFilterList, successCount, associatedApplicationId
  } = useIdentifiersDialogsStore(useShallow(state => ({
    closeManageIdentifierPop: state.closeManageIdentifierPop,
    closeSingleIdentifierPop: state.closeSingleIdentifierPop,
    updateOpenBulkIdentifierDialog: state.updateOpenBulkIdentifierDialog,
    onBatchIdentifierSuccess: state.onBatchIdentifierSuccess,
    onSingleIdentifierSuccess: state.onSingleIdentifierSuccess,
    openManageIdentifierPop: state.openManageIdentifierPop,
    showSingleManageIdentifierPop: state.showSingleManageIdentifierPop,
    showManageIdentifierPop: state.showManageIdentifierPop,
    openBulkIdentifierDialog: state.openBulkIdentifierDialog,
    initFilterList: state.initFilterList,
    disabledList: state.disabledList,
    defaultAutoCheckedList: state.defaultAutoCheckedList,
    disableIdentifierList: state.disableIdentifierList,
    successCount: state.successCount,
    associatedApplicationId: state.associatedXevmpdId,
  })));

   const shouldDisableRightItem = (
    rightItem: any,
    leftItem: any,
    currentSelections: (string | number)[]
  ) => {
    if (
      currentSelections.length > 0 &&
      ((disabledList && disabledList[leftItem.value]) ||
        (hasTriggerSelectioRef.current[leftItem.value] &&
          defaultIdentifierList &&
          defaultIdentifierList[leftItem.value]?.length > 0))
    ) {
      const changeLeftToArr = toArray(disabledList[leftItem.value]);
      const changeDefaultToArr = toArray(defaultIdentifierList[leftItem.value]);
      return (
        changeLeftToArr.includes(rightItem.value) ||
        (hasTriggerSelectioRef.current[leftItem.value] &&
          currentSelections.length > 0 &&
          changeDefaultToArr.includes(rightItem.value))
      );
    }
    return false;
  };

  const shouldDisableRightItemUncheck = (rightItem: any, leftItem: any) => {
    if (!disableIdentifierList?.includes?.(leftItem.value)) {
      return false;
    }

    if (
      (disabledList && disabledList[leftItem.value]) ||
      (hasTriggerSelectioRef.current[leftItem.value] &&
        defaultIdentifierList &&
        defaultIdentifierList[leftItem.value]?.length > 0)
    ) {
      const changeLeftToArr = toArray(disabledList[leftItem.value]);
      const changeDefaultToArr = toArray(defaultIdentifierList[leftItem.value]);
      return (
        changeLeftToArr.includes(rightItem.value) ||
        (hasTriggerSelectioRef.current[leftItem.value] &&
          changeDefaultToArr.includes(rightItem.value))
      );
    }
    return false;
  };

    const resolveAutoSelections = (
    currentSelections: (string | number)[],
    leftItem: any,
    allRightItems: any[]
  ) => {
    identifierMapAll.current[leftItem.value] = allRightItems.length === currentSelections.length;
    if (defaultIdentifierList?.[leftItem.value]?.length > 0) {
      hasTriggerSelectioRef.current[leftItem.value] = true;
      return defaultIdentifierList[leftItem.value];
    }
    return [];
  };

  return (
    <div>
   
      <IdentifiersDialog
        open={showManageIdentifierPop || showSingleManageIdentifierPop}
        //setLoading={setLoading}
        isBatchMode={showManageIdentifierPop}
        title={t("identifiers.title")}
        defaultIdentifiersKey={disableIdentifierList}
        initialIdentifierMap={initFilterList || {}}
        selectedRecordsCount={rowSelectionModel?.length}
        shouldDisableRightItem={shouldDisableRightItem}
        shouldDisableRightItemUncheck={shouldDisableRightItemUncheck}
        resolveAutoSelections={resolveAutoSelections}
        onClose={() => {
          document.body.classList.remove('identifiers-dialog-open');
          if (showSingleManageIdentifierPop) {
            closeSingleIdentifierPop();
          } else {
            closeManageIdentifierPop();
          }
        }}
        onSave={(item: any) => {
          if (showSingleManageIdentifierPop) {
            saveSingleBindIdentifier(item);
          } else {
            saveBatchBindIdentifier(item);
          }
        }}
      />

      <Dialog
        open={openBulkIdentifierDialog}
        maxWidth="xs"
        fullWidth
        className="popup-dialog"
        slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(15, 15, 15, 0.4) !important",
          },
        },
      }}
      >
        <Box component="form" sx={{ display: "flex", flexDirection: "column" }}>
          <DialogContent className="form-group popup-content">
            <Grid container>
              <Grid item xs={12} sx={{ position: "relative" }}>
                <img
                  alt=""
                  className="common-dialog-delete-img"
                  src={SuccessIcon}
                ></img>
                <Typography variant="h5" sx={{ textAlign: "center" }} gutterBottom>
                  {t?.("identifiers.updateSuccessTip") ?? "Identifiers updated successfully!"}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ my: 2 }}
                  className="alert-notify-text text-center"
                >
                  {(t?.("identifiers.updateSuccessTipWithNumber", {
                    successCount: successCount,
                    allCount: rowSelectionModel?.length,
                  })) ??
                    `${successCount} out of ${rowSelectionModel?.length} record(s) updated successfully!`}
                </Typography>
              </Grid>

              <Grid item xs={12} textAlign={"center"} sx={{ my: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    updateOpenBulkIdentifierDialog(false);
                    setRowSelectionModel?.([]);
                  }}
                >
                  {t?.("common.yes") ?? "Yes"}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Box>
      </Dialog>
    </div>
  );
});

// export const openIdentifiersDialog = (options?: {
//   mode?: "batch" | "single";
//   initialIdentifierMap?: Record<string, string[]>;
// }) => {
  // const { mode = "batch", initialIdentifierMap = {} } = options || {};
  // if (mode === "batch") {
  //   // openManageIdentifierPop(initialIdentifierMap);
  // } else {
  //   // openSingleManageIdentifierPop(initialIdentifierMap);
  // }
// };


